import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, retry, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RetryInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method !== 'GET') return next.handle(req);
    return next.handle(req).pipe(
      retry({
        count: 2,
        delay: (_err, retryIndex) => timer(300 * 2 ** retryIndex),
      }),
    );
  }
}
